/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import StarRatingComponent from "components/StarRatingComponent";

export default function SurveyForm({
  data,
  overall,
  onDataUpdate,
  questions,
  error,
  loading,
}) {
  const [ratingsDetails, setRatingsDetails] = useState(data);
  const [comment, setComment] = useState(overall.overallComment);
  const [overallRating, setOverallRating] = useState(overall.overallRating);

  useEffect(() => {
    if (!ratingsDetails) return; // Prevent mapping over undefined

    const addToData = ratingsDetails
      .filter((ratingDetail) => ratingDetail !== undefined) // Filter out undefined entries
      .map((ratingDetail) => ({
        questionId: ratingDetail?.questionId, // Ensure safe access
        categoryId: ratingDetail?.categoryId,
        rating: parseInt(ratingDetail?.rating, 10) || 0,
      }));

    onDataUpdate({
      data: addToData,
      overallComment: comment,
      overallRating: parseInt(overallRating, 10) || 0,
    });
  }, [overallRating, comment, ratingsDetails]);

  const handleRatingChange = (index, value, question) => {
    setRatingsDetails((prevRatings) => {
      const newRatings = [...prevRatings];

      // Update the rating for the current question
      newRatings[index] = {
        rating: value,
        questionId: question.id,
        categoryId: question.categoryId ?? question.id, // Ensure categoryId is always set
        ...question,
      };

      // Ensure question ID 5 is always present with categoryId 5 and rating 0
      const question5Index = newRatings.findIndex((q) => q.questionId === 5);
      if (question5Index === -1) {
        newRatings.push({
          questionId: 5,
          rating: 0,
          categoryId: 5, // Ensure categoryId is explicitly set to 5
        });
      } else {
        newRatings[question5Index].categoryId = 5; // Ensure categoryId is set correctly
      }

      return newRatings;
    });
  };

  useEffect(() => {
    console.log("Survey Questions:", questions);
    console.log("Initial Data:", data);
    console.log("Overall:", overall);
  }, []);

  return (
    <Box
      sx={{
        // my: 5,
        width: "100%",
      }}
    >
      <Typography>{loading ? "Loading..." : ""}</Typography>
      <Typography sx={{ color: "red", fontWeight: "bold" }}>
        {error}
        {error ? " (Unable to display questions)" : ""}
      </Typography>
      {!error && (
        <>
          <Box
            sx={{
              my: { xs: 2, xl: 5 },
              ml: 3,
              gap: 1,
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <Typography
              mr={2}
              sx={{
                fontFamily: "Poppins",
                fontStyle: "normal",
                fontSize: {
                  xs: "0.875rem",
                  sm: "1rem",
                  md: "0.8rem",
                  xl: "1rem",
                },
              }}
            >
              Kindly rate the quality of service provided by checking the
              appropriate button.
            </Typography>
            <Typography
              sx={{
                fontWeight: "bold",
                fontFamily: "Poppins",
                fontSize: {
                  xs: "0.875rem",
                  sm: "1rem",
                  md: "0.8rem",
                  xl: "1rem",
                },
              }}
            >
              5 is the highest and 1 is the lowest
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "left",
              fontWeight: 500,
              fontFamily: "Poppins",
            }}
          >
            {questions?.map((question, index) => (
              <React.Fragment key={question.id}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Poppins",
                    fontWeight: 500,

                    fontStyle: "normal",
                    justifyContent: "space-between",
                    width: "95%",
                    mb: 1,
                  }}
                >
                  <Box>
                    <Box sx={{ display: "flex" }}>
                      <Typography sx={{ mr: 1 }}>{index + 1}.</Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontFamily: "Poppins",
                          fontSize: {
                            xs: "0.875rem",
                            sm: "1rem",
                            md: "0.8rem",
                            xl: "1rem",
                          },
                        }}
                      >
                        {question.categoryTitle}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Grid
                  container
                  spacing={0}
                  sx={{
                    boxShadow: "1px 2px 5px 1px rgba(65, 65, 65, 0.8)",
                    width: "95%",
                    borderRadius: "10px",
                    p: 2,
                    mb: 2,
                  }}
                >
                  <Grid item xs={12}>
                    <Box>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.875rem",
                            sm: "1rem",
                            md: "0.8rem",
                            xl: "1rem",
                          },
                          fontFamily: "Poppins",
                          fontStyle: "normal",
                          fontWeight: 500,
                          ml: 2,
                        }}
                      >
                        {question.description}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                    }}
                  >
                    <FormControl
                      component="fieldset"
                      sx={{ ml: { xs: 0, sm: 2 }, mt: { xs: 2, xl: 4 } }}
                    >
                      <RadioGroup
                        aria-label={`rating-${index}`}
                        name={`rating-${index}`}
                        column
                        // value={
                        //   ratingsDetails[index]?.rating !== undefined &&
                        //   ratingsDetails[index]?.rating !== null
                        //     ? ratingsDetails[index]?.rating.toString()
                        //     : ""
                        // }
                        // value={
                        //   question.id === 5
                        //     ? "0" // Force selection of 0 for question.id === 5
                        //     : ratingsDetails[index]?.rating !== undefined &&
                        //       ratingsDetails[index]?.rating !== null
                        //     ? ratingsDetails[index]?.rating.toString()
                        //     : ""
                        // }
                        value={
                          question.id === 5
                            ? "0" // Only enforce for question ID 5
                            : ratingsDetails
                                .find((q) => q.questionId === question.id)
                                ?.rating?.toString() || ""
                        }
                        onChange={(evt) =>
                          handleRatingChange(index, evt.target.value, question)
                        }
                        sx={{
                          display: "flex",
                          flexDirection: {
                            xs: "column",
                            sm: "row",
                            xl: "column",
                            md: "column",
                          }, // Stack on mobile, horizontal on desktop
                          flexWrap: "wrap", // Prevents overflow
                          gap: { xs: 1, sm: 2, md: 0.5 }, // Adds spacing between radio options
                          "@media (min-height: 1080px)": {
                            flexDirection: "column",
                            alignItems: "flex-start",
                          },
                        }}
                      >
                        {[5, 4, 3, 2, 1, 0].map((value) => {
                          const labels = {
                            5: "5 - Strongly Agree",
                            4: "4 - Agree",
                            3: "3 - Neither Agree nor Disagree",
                            2: "2 - Disagree",
                            1: "1 - Strongly Disagree",
                            0: "0 - Not Applicable",
                          };

                          return (
                            <FormControlLabel
                              key={value}
                              value={value.toString()}
                              control={
                                <Radio
                                  sx={{
                                    transform: {
                                      xs: "scale(1.1)",
                                      sm: "scale(1.2)",
                                    }, // Larger for touch accessibility
                                  }}
                                  disabled={question.id === 5 && value !== 0} // Disable all except 0
                                />
                              }
                              label={
                                <Typography
                                  sx={{
                                    fontSize: {
                                      xs: "0.85rem",
                                      sm: "1rem",
                                      md: "0.8rem",
                                      xl: "1rem",
                                    }, // Adjust label size
                                    fontWeight: 500,
                                    whiteSpace: "nowrap", // Prevents wrapping on larger screens
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {labels[value]}
                                </Typography>
                              }
                              sx={{
                                mx: { xs: 0, sm: 1 }, // Reduces margin on small screens
                              }}
                            />
                          );
                        })}
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </React.Fragment>
            ))}

            <Box sx={{ width: "98%", my: 2 }}>
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "0.8rem", md: "0.8rem", xl: "1rem" },
                }}
              >
                Overall Rating
              </Typography>
              <StarRatingComponent
                overallRating={overallRating}
                setOverallRating={setOverallRating}
              />
            </Box>
            <Box sx={{ width: "98%", mb: 4 }}>
              <Typography
                sx={{
                  fontWeight: "bold",
                  mb: 2,
                  fontSize: { xs: "0.8rem", md: "0.8rem", xl: "1rem" },
                }}
              >
                Suggestions/Complaints/Concerns (Suhestiyon/Reklamo/Komento) :
              </Typography>
              <TextField
                label="Add a Comment"
                multiline
                rows={4}
                variant="outlined"
                value={comment}
                onChange={(evt) => setComment(evt.target.value)}
                fullWidth
              />
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
}
